import { Outlet } from 'react-router';

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { AllEnterpriseModule, IntegratedChartsModule, ModuleRegistry } from 'ag-grid-enterprise';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

import { GlobalLoader, PermissionsProvider } from '@enterprise/ui';

import { useRootConfiguration } from './hooks/root-configuration.hook';

ModuleRegistry.registerModules([AllEnterpriseModule, IntegratedChartsModule.with(AgChartsEnterpriseModule)]);

const Root = () => {
  const { isAuthorized } = useRootConfiguration();

  return (
    <NuqsAdapter>
      <PermissionsProvider isAuthorized={isAuthorized}>
        <GlobalLoader />
        <Outlet />
      </PermissionsProvider>
    </NuqsAdapter>
  );
};

export default Root;
